import type { Candidate, CandidateEvent, CandidatePage, CandidateQuery, CandidateUpdate } from "@shared/modules/x-candidats";
import { api } from "../../../core/lib/api";

export function listCandidates(q: Partial<CandidateQuery>): Promise<CandidatePage> {
  const params = new URLSearchParams();
  for (const [k, v] of Object.entries(q)) if (v !== undefined && v !== "" && v !== null) params.set(k, String(v));
  return api<CandidatePage>(`/api/candidats?${params.toString()}`);
}

export function getCandidate(id: string, reveal = false): Promise<Candidate> {
  return api<Candidate>(`/api/candidats/${id}${reveal ? "?reveal=1" : ""}`);
}

export function createCandidate(input: CandidateUpdate): Promise<Candidate> {
  return api<Candidate>("/api/candidats", { method: "POST", body: JSON.stringify(input) });
}

export function updateCandidate(id: string, input: CandidateUpdate): Promise<Candidate> {
  return api<Candidate>(`/api/candidats/${id}`, { method: "PATCH", body: JSON.stringify(input) });
}

export function deleteCandidate(id: string): Promise<void> {
  return api<void>(`/api/candidats/${id}`, { method: "DELETE" });
}

export function candidateHistory(id: string): Promise<CandidateEvent[]> {
  return api<CandidateEvent[]>(`/api/candidats/${id}/historique`);
}

export function lawyerOptions(): Promise<{ id: string; name: string; email: string }[]> {
  return api("/api/candidats/options/avocats");
}

export function assignLawyer(candidateId: string, userId: string) {
  return api<{ userId: string; name: string; email: string }[]>(`/api/candidats/${candidateId}/avocats`, { method: "POST", body: JSON.stringify({ userId }) });
}

export function unassignLawyer(candidateId: string, userId: string): Promise<void> {
  return api<void>(`/api/candidats/${candidateId}/avocats/${userId}`, { method: "DELETE" });
}
